import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import FormattedMessage from 'components/FormattedMessage'

import './index.less'

const CancellationRules = ({ rules, className }) => (
  <div className={classNames('cancellation-rules', className)}>
    <h3 className="cancellation-rules__title">
      <FormattedMessage id="cancellationRules.title" />
    </h3>

    <ul className="cancellation-rules__items">
      {rules.map(({ percentage, daysToEvent, id }) => (
        <li key={id}>
          <span>
            <FormattedMessage
              id="cancellationRules.item"
              values={{ percentage, daysToEvent }}
            />
          </span>
        </li>
      ))}
    </ul>
  </div>
)

CancellationRules.propTypes = {
  className: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      daysToEvent: PropTypes.number.isRequired,
      percentage: PropTypes.string.isRequired,
    }),
  ),
}

export default CancellationRules
